import { render, staticRenderFns } from "./modalDescargarCatalogo.vue?vue&type=template&id=ffea7e0a&scoped=true"
import script from "./modalDescargarCatalogo.vue?vue&type=script&lang=js"
export * from "./modalDescargarCatalogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea7e0a",
  null
  
)

export default component.exports